import { z } from 'zod';
import { cashSessionIdSchema, tenantIdSchema, userIdSchema } from '../ids/index.js';
import { cents } from '../money/index.js';
export const cashMovementType = {
    open: 'open',
    close: 'close',
    sale: 'sale',
    refund: 'refund',
    in: 'in',
    out: 'out',
    drop: 'drop',
};
export const cashSessionSchema = z.object({
    id: cashSessionIdSchema,
    tenantId: tenantIdSchema,
    userId: userIdSchema,
    openedAt: z.number().int(),
    closedAt: z.number().int().nullable().default(null),
    openingCashCents: cents,
    closingCashCents: cents.nullable().default(null),
    expectedCashCents: cents.nullable().default(null),
    differenceCents: z.number().int().nullable().default(null),
    note: z.string().max(500).nullable().default(null),
    version: z.number().int().min(1).default(1),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
});
export const cashMovementSchema = z.object({
    id: z.string().uuid(),
    tenantId: tenantIdSchema,
    cashSessionId: cashSessionIdSchema,
    type: z.enum(['open', 'close', 'sale', 'refund', 'in', 'out', 'drop']),
    amountCents: cents,
    reason: z.string().max(500).nullable().default(null),
    at: z.number().int(),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
});
//# sourceMappingURL=cash.js.map